var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "zj-mainpage-main" },
    [
      _c("audio", {
        ref: "audio",
        attrs: {
          controls: "controls",
          hidden: "",
          muted: "",
          src: "static/sounds/钉钉提示音.mp3",
        },
      }),
      _vm._v(" "),
      _c(
        "el-container",
        { staticClass: "zj-mainpage-ct" },
        [
          _c("el-header", { staticClass: "zj-mainpage-topheader" }, [
            _c("div", { staticClass: "zj-mainpage-topheader-left" }, [
              _c("img", {
                staticStyle: { cursor: "pointer" },
                attrs: { src: "assets/logo/" + _vm.$SYSTEM_ICON, height: "35" },
                on: { click: _vm.refreshPage },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "zj-mainpage-sysname",
                  on: { click: _vm.refreshPage },
                },
                [_vm._v(_vm._s(_vm.$SYSTEM_NAME))]
              ),
            ]),
            _vm._v(" "),
            _vm.breadCrumbList.breadCrumbList.length > 1
              ? _c(
                  "div",
                  { staticClass: "zj-mainpage-breadcrumb-ct" },
                  [_c("nav-breadcrumb")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("ul", { staticClass: "zj-mainpage-topheader-right" }, [
              _c(
                "li",
                { attrs: { "data-step": "1", "data-intro": "查看消息" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        content: "查看消息",
                        placement: "bottom-start",
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "el-icon-message-solid",
                          staticStyle: { position: "relative" },
                          on: {
                            click: function ($event) {
                              _vm.showMsg = true
                            },
                          },
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.msgList.length > 0,
                                expression: "msgList.length > 0",
                              },
                            ],
                            staticClass: "zj-message-unread",
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "el-dropdown",
                    { attrs: { trigger: "hover", szie: "medium" } },
                    [
                      _c("span", { staticClass: "zj-mainpage-dropdown-span" }, [
                        _c("i", {
                          staticClass: "el-icon-question",
                          on: { click: _vm.startGuide },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticStyle: { "min-width": "150px" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.downLoadOneDoc()
                                },
                              },
                            },
                            [_vm._v("下载操作手册")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { attrs: { "data-step": "2", "data-intro": "切换公司" } },
                [
                  _c(
                    "el-dropdown",
                    { attrs: { trigger: "hover", szie: "medium" } },
                    [
                      _c("span", { staticClass: "zj-mainpage-dropdown-span" }, [
                        _c("i", { staticClass: "el-icon-menu" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.accountInfo.company.c_name)),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticStyle: { "min-width": "150px" },
                          attrs: { slot: "dropdown", "hide-timeout": "500" },
                          slot: "dropdown",
                        },
                        _vm._l(
                          _vm.accountInfo.companies,
                          function (item, index) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: index,
                                attrs: { icon: "el-icon-menu" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.selectCompany(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.c_name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { attrs: { "data-step": "3", "data-intro": "个人中心" } },
                [
                  _c(
                    "el-dropdown",
                    { attrs: { trigger: "hover", szie: "medium" } },
                    [
                      _c(
                        "span",
                        { staticClass: "zj-mainpage-dropdown-span" },
                        [
                          _c("i", { staticClass: "el-icon-user" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.accountInfo.emp_name)),
                          ]),
                          _vm._v(" "),
                          _vm.needBindCount > 0
                            ? _c("el-badge", {
                                staticClass: "item-badge",
                                attrs: { value: _vm.needBindCount },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticStyle: { "min-width": "150px" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  _vm.changePasswordVisible = true
                                },
                              },
                            },
                            [_vm._v("修改密码")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.bindEmail.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v("绑定邮箱\n                "),
                              !_vm.accountInfo.email
                                ? _c("el-badge", {
                                    staticClass: "item",
                                    attrs: { value: 1, size: "mini" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.bindWX.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v("绑定微信\n                "),
                              !_vm.accountInfo.wx_unionid
                                ? _c("el-badge", {
                                    staticClass: "item",
                                    attrs: { value: 1 },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { divided: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.logout.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("退出登录")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("li", [_c("screen-full")], 1),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _c(
                "el-aside",
                {
                  staticClass: "zj-mainpage-aside-ct",
                  attrs: {
                    width: _vm.isCollapse ? "64px" : "200px",
                    "data-step": "4",
                    "data-intro": "菜单导航",
                  },
                },
                [
                  _c("nav-menu-tree-collapse", {
                    attrs: { isCollapse: _vm.isCollapse },
                    on: {
                      "update:isCollapse": function ($event) {
                        _vm.isCollapse = $event
                      },
                      "update:is-collapse": function ($event) {
                        _vm.isCollapse = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isDeveloper
                    ? _c(
                        "el-menu",
                        {
                          staticStyle: {
                            width: "100%",
                            "background-color": "#ddecfd",
                          },
                          attrs: { collapse: "" },
                        },
                        [
                          _c(
                            "el-submenu",
                            { attrs: { index: "otherFlatForm" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-more" }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu-item-group",
                                [
                                  _vm.isAdmin || _vm.isDeveloper
                                    ? _c(
                                        "el-menu-item",
                                        { on: { click: _vm.openBsm } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-s-management",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "title" },
                                              slot: "title",
                                            },
                                            [_vm._v("后台管理")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDeveloper
                                    ? _c(
                                        "el-menu-item",
                                        { on: { click: _vm.openDev } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-monitor",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "title" },
                                              slot: "title",
                                            },
                                            [_vm._v("开发者后台")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-container",
                [
                  _c(
                    "el-header",
                    { staticClass: "zj-mainpage-navheader" },
                    [_c("nav-bar")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-main",
                    { staticClass: "zj-mainpage-childpage-ct" },
                    [
                      _c(
                        "keep-alive",
                        [
                          _vm.$route.meta.keepAlive === true
                            ? _c("router-view", {
                                ref: "routerPage",
                                staticClass: "zj-mainpage-childpage-common",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$route.meta.keepAlive !== true
                        ? _c("router-view", {
                            ref: "routerPage",
                            staticClass: "zj-mainpage-childpage-common",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeTabName == "main" ? _c("home-page") : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "消息列表",
            "close-on-click-modal": "",
            visible: _vm.showMsg,
            width: "800px",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showMsg = $event
            },
          },
        },
        [_c("msg")],
        1
      ),
      _vm._v(" "),
      _c("changePwd", {
        attrs: { visible: _vm.changePasswordVisible },
        on: {
          "update:visible": function ($event) {
            _vm.changePasswordVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            width: "450px",
            title: "二维码绑定",
            visible: _vm.qrVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrVisible = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { height: "400px" } }, [
              _c("div", { staticClass: "image-div" }, [
                _c("img", {
                  staticClass: "center-png",
                  attrs: { src: "assets/logo/logo_circle.png" },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "qrcode-ct" }, [
                _c(
                  "div",
                  { on: { click: _vm.getQrCodeByBind } },
                  [
                    _c("vue-qr", {
                      staticStyle: { border: "1px solid #eee" },
                      attrs: {
                        text: _vm.qr_src,
                        binarize: "",
                        size: 200,
                        margin: 10,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "qr-tip" }, [
                  _vm._v(_vm._s(_vm.qr_tip)),
                ]),
              ]),
            ]),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            width: "450px",
            title: "邮箱 绑定",
            visible: _vm.emailVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.emailVisible = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "image-div" }, [
              _c("img", {
                staticClass: "center-png",
                attrs: { src: "assets/logo/logo_circle.png" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-area" }, [
              _c(
                "div",
                { staticClass: "input-item" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入注册邮箱" },
                    model: {
                      value: _vm.emailNumber,
                      callback: function ($$v) {
                        _vm.emailNumber = $$v
                      },
                      expression: "emailNumber",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-item",
                  staticStyle: { display: "flex", "flex-direction": "row" },
                },
                [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "验证码" },
                        model: {
                          value: _vm.checkPassword,
                          callback: function ($$v) {
                            _vm.checkPassword = $$v
                          },
                          expression: "checkPassword",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "40px",
                        "margin-left": "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sendAuthCode,
                              expression: "sendAuthCode",
                            },
                          ],
                          staticStyle: { "margin-left": "30px" },
                          on: { click: _vm.getAuthCode },
                        },
                        [_vm._v("\n              获取验证码\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.sendAuthCode,
                              expression: "!sendAuthCode",
                            },
                          ],
                          attrs: { disabled: _vm.sendAuthCode },
                          on: { click: _vm.getAuthCode },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.auth_time) +
                              "秒之后重新发送验证码\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "login-button-ct" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "login-button",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmEmail()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.bindText))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "login-button",
                      staticStyle: { "margin-left": "20px" },
                      on: {
                        click: function ($event) {
                          _vm.emailVisible = !_vm.emailVisible
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ]),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }